import React from 'react'

const CloseMonth = ({month}) => {
  
  const getDataEachMonth = (month) => {
     switch(month){
        case 'January':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >1</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>1 ရက်နေ့ - ( Wednesday ) New Year`s Day National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>27 ရက်နေ့ - ( Monday ) Ascension of the prophet Muhammad National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>28 ရက်နေ့ - ( Tuesday) Chinese New Year National Holiday</li>
            </ul>
        </>;
        case 'March':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >2</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>1 ရက်နေ့ - ( Saturday)  First Day of Ramadan Not Public Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>17 ရက်နေ့ - ( Monday) Nuzul AI- Quran Not Public Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>28 ရက်နေ့ - ( Friday) Bali`s Day of Silence and Hindu New Year Holiday National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>29 ရက်နေ့ - ( Saturday) Bali`s Day of Silence and Hindu New Year Holiday National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>31 ရက်နေ့ - ( Monday ) Hari Raya Idul Fitri National Holiday</li>
            </ul>
        </>;
        case 'April':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >3</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>1 ရက်နေ့ - ( Tuesday )Hari Raya Idul Fitri National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>2 ရက်နေ့ - ( Wednesday ) Hari Raya Idul Fitri National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>3 ရက်နေ့ - ( Thursday )Hari Raya Idul Fitri National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>4 ရက်နေ့ - ( Friday )Hari Raya Idul Fitri NationalHoliday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>7 ရက်နေ့ - ( Monday ) Hari Raya Idul Fitri National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>13 ရက်နေ့ - ( Sunday ) Myanmar Water Festival</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>14 ရက်နေ့ - ( Monday ) Myanmar Water Festival</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>15 ရက်နေ့ - ( Tuesday ) Myanmar Water Festival</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>16 ရက်နေ့ - ( Wednesday ) Myanmar Water Festival</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>17 ရက်နေ့ - ( Thursday )Myanmar New Year Day </li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>18 ရက်နေ့ - ( Friday )Good Friday National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>20 ရက်နေ့ - ( Sunday ) Easter Sunday National Holiday</li>
            </ul>
        </>;
        case 'May':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >4</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>1 ရက်နေ့ - ( Thursday ) Labour Day National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>12 ရက်နေ့ - ( Monday )  Waisak Day ( Buddha`s Anniversary )  National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>13 ရက်နေ့ - ( Tuesday )  Waisak Day Holiday National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>29 ရက်နေ့ - ( Thursday )  Ascension Day of Jesus Christ National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>30 ရက်နေ့ - ( Friday)  Ascension Day of Jesus Christ National Holiday</li>
            </ul>
        </>;
        case 'June':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >5</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>1 ရက်နေ့ - ( Sunday ) Pancasila Day National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>4 ရက်နေ့ - ( Wednesday ) First Day Of Hajj Not Public Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>6 ရက်နေ့ - ( Friday ) Muslim Day of Sacrifice ( Idul Adha ) National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>9 ရက်နေ့ - ( Monday ) Muslim Day Of Sacrifice ( idul Adha )  Holiday National Holiday</li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>27 ရက်နေ့ - ( Friday ) Islamic New Year</li>
            </ul>
        </>;
        case 'August':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >6</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>17 ရက်နေ့ - ( Sunday )Indonesia Independence Day National Holiday</li>
            </ul>
        </>;
        case 'September':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >7</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>5 ရက်နေ့ - ( Friday ) Prophet Muhammad`s Brithday National Holiday</li>
            </ul>
        </>
        case 'October':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >8</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>6 ရက်နေ့ - ( Monday ) Fullmoon of Thadingyut Festival </li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>21 ရက်နေ့ - ( Tuesday ) Deepavail Not Public Holiday </li>
            </ul>
        </>;
        case 'December':
        return <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {/* <div
                    style={{
                        width: '25px',
                        height: '25px',
                        backgroundColor: 'var(--accent-color)',
                        borderRadius: '15px',
                        textAlign: 'center',
                        lineHeight: '25px',
                        marginRight: '10px',
                    }}
                >9</div> */}
                <span style={{color: 'var(--accent-color)', marginRight: '5px'}}>{month}</span> လ အတွက်
            </div>
            <ul style={{paddingInlineStart: '40px'}}>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>25 ရက်နေ့ - ( Thursday) Christmas Day National Holiday </li>
                <li style={{fontSize: '14px', marginBottom: '6px'}}>26 ရက်နေ့ - ( Friday ) Christmas Day National Holiday </li>
            </ul>
        </>

     }
  };

  return (
    <div className='showCloseDaysList'>
       {
        getDataEachMonth(month)
       }
    </div>
  )
}

export default CloseMonth
